import { context } from '@shared-services/context-service';
import withErrorBoundary from 'client/widget-components/components/ErrorBoundary/withErrorBoundary';
import { ResponsiveStylesProp } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React, { FC, MouseEvent, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';
import { SearchBtn } from './SearchBtn/SearchBtn';
import { SearchPopup } from './SearchPopup/SearchPopup';
import { CollectionsToSearch, SearchLayout } from './types';

const UNMOUNT_TIMEOUT = 500;

export interface RuntimeCollectionSearchProps {
    widgetId: string;
    placeholder?: string;
    layout?: SearchLayout;
    _styles?: {
        iconBtn?: ResponsiveStylesProp;
        input?: ResponsiveStylesProp;
        inputFocus?: ResponsiveStylesProp;
        popup?: ResponsiveStylesProp;
        dropdown?: ResponsiveStylesProp;
        dropdownItemHover?: ResponsiveStylesProp;
    };
    collectionsToSearch?: CollectionsToSearch;
}

const RuntimeCollectionSearch: FC<RuntimeCollectionSearchProps> = ({
    widgetId,
    placeholder,
    _styles: styles,
    collectionsToSearch = [
        {
            name: 'catalog_product',
            path: 'product',
        },
    ],
    layout = SearchLayout.ROUND,
}) => {
    const animatedBlockRef = useRef<HTMLDivElement>(null);
    const [isSearchPopupOpen, setIsSearchPopupOpen] = useState(false);

    const inputRef = useRef<HTMLInputElement>(null);

    const openSearchPopup = (e: MouseEvent<HTMLButtonElement>) => {
        if (context.isEditor) {
            return;
        }
        setIsSearchPopupOpen(true);
        inputRef?.current?.focus();
        e.preventDefault();
    };

    const closeSearchPopup = () => {
        setIsSearchPopupOpen(false);
    };

    return (
        <div>
            <SearchBtn styles={styles} openSearchPopup={openSearchPopup} />

            <Transition
                nodeRef={animatedBlockRef}
                in={isSearchPopupOpen}
                timeout={UNMOUNT_TIMEOUT}
            >
                {(animationState: string) => (
                    <SearchPopup
                        inputRef={inputRef}
                        widgetId={widgetId}
                        placeholder={placeholder}
                        layout={layout}
                        styles={styles}
                        collectionsToSearch={collectionsToSearch}
                        animatedBlockRef={animatedBlockRef}
                        animationState={animationState}
                        closeSearchPopup={closeSearchPopup}
                    />
                )}
            </Transition>
        </div>
    );
};

const BoundedCollectionSearch = withErrorBoundary({
    Comp: RuntimeCollectionSearch,
    componentName: 'RuntimeSearch',
});

const RuntimeCollectionSearchWidget = (props: RuntimeCollectionSearchProps) => (
    <BoundedCollectionSearch {...props} />
);

export default RuntimeCollectionSearchWidget;
